import { ComponentInfo, StaticText } from '@ipensii/shared/domain-shared';
import { AbstractJsonApiService, JsonApiResourceEmptyMetadata } from './abstract-json-api.service';
import { JsonApiResource } from '@irian-ro/abstract-resource';
import { map, Observable } from 'rxjs';

export class ComponentInfoService extends AbstractJsonApiService<ComponentInfo> {
  constructor() {
    super('component-info');
  }

  updateStaticTextJsonApi(resource: StaticText) {
    return this.http.post<JsonApiResource<StaticText, JsonApiResourceEmptyMetadata>>(`${this.url}/static-text`, resource);
  }

  updateStaticText({ resource }: { resource: StaticText }): Observable<StaticText> {
    return this.updateStaticTextJsonApi(resource).pipe(map((res) => res.data));
  }
}
